const SHADOW_VALUE_SEPARATOR = '_';

const parseShadowValue = (value) => {
  const [shiftX, shiftY, blurRadius, spreadRadius, ...colorParts] =
    value.split(SHADOW_VALUE_SEPARATOR);
  const color = colorParts.join(SHADOW_VALUE_SEPARATOR);

  return { shiftX, shiftY, blurRadius, spreadRadius, color };
};

const buildShadowValue = (shiftX, shiftY, blurRadius, spreadRadius, color) =>
  [shiftX, shiftY, blurRadius, spreadRadius, color].join(SHADOW_VALUE_SEPARATOR);

const patchShadowValue = (currentValue, patches) => {
  const currentParts = parseShadowValue(currentValue);

  return buildShadowValue(
    patches.shiftX ?? currentParts.shiftX,
    patches.shiftY ?? currentParts.shiftY,
    patches.blurRadius ?? currentParts.blurRadius,
    patches.spreadRadius ?? currentParts.spreadRadius,
    patches.color ?? currentParts.color
  );
};

export { buildShadowValue, patchShadowValue };
